/*@flow*/

export default (baseHeight: number | string): number | string => window.innerHeight < baseHeight ? window.innerHeight - 40 : baseHeight;
